import React from 'react'
import { TextField } from '@mui/material'

const TextBox = ({ label, onChange, value, disabled, onBlur, error, helperText, type }) => {
  return (
    <TextField
      fullWidth
      label={label}
      size="small"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      helperText={helperText}
      disabled={disabled}
      type={type}
      InputProps={
        disabled && {
          style: {
            color: '#ccc',
            backgroundColor: 'hsl(0, 0%, 95%)',
          },
        }
      }
    />
  )
}

export default TextBox
